export default __webpack_public_path__ + "static/media/alt_profile.fa9ed935.svg";